<div class="loader-wrapper" [class.loderhide]="!show">
  <div class="typewriter">
    <h1>Welcome to University Management System..</h1>
  </div>
</div>
